import {CONSTANTS} from '@/constants';
import navGuest from '@/nav/guest'
import navGod from '@/nav/god'
import navDemo from '@/nav/_nav'
import navAdmin from '@/nav/admin'
import navAgent from '@/nav/agent'
import navAgency from '@/nav/agency'
import navManager from '@/nav/manager'
import navBuh from '@/nav/buh'
import navTech from '@/nav/tech'
import navJur from '@/nav/jur'
import navWebm from '@/nav/webm'


function getApiBaseUrl()
{
    if (window.location.hostname === 'zt.nsb.su') {
        if (CONSTANTS.CONFIG === 'dev')
            return 'https://devapi.nsb.su/api/';
        else
            return 'https://api.nsb.su/api/';
    }
    else if (window.location.hostname === 'cp.nsb.su') {
        if (CONSTANTS.CONFIG === 'dev')
            return 'https://devapi.nsb.su/api/';
        else
            return 'https://api.nsb.su/api/';
    }
    else {
        if (window.location.hostname === 'dev.nsb.su') {
            return 'https://devapi.nsb.su/api/';
        } else {
            return 'http://api.nsb.loc/api/';
        }
    }

}


function getApiLoginUrl() {
    if (window.location.hostname === 'zt.nsb.su') {
        if (CONSTANTS.CONFIG === 'dev')
            return 'https://dev.nsb.su/api/auth/login/';
        else
            return 'https://zt.nsb.su/api/auth/login/';
    }
    else if (window.location.hostname === 'cp.nsb.su') {
        if (CONSTANTS.CONFIG === 'dev')
            return 'https://dev.nsb.su/api/auth/login/';
        else
            return 'https://cp.nsb.su/api/auth/login/';
    }
    else {
        if (window.location.hostname === 'dev.nsb.su') {
            return 'https://dev.nsb.su/api/auth/login/';
        } else {
            return 'http://zt.nsb.loc/api/auth/login/';
        }
    }
}


let STORE = {
    state: {
        apibaseurl: getApiBaseUrl(),
        apiloginurl: getApiLoginUrl(),
        authtoken:null,
        navmode:'guest',
        navmenu:navGuest,
        user:null,
        company:null,
        status:{},
        voucherFilters:{
            statusFilter:CONSTANTS.VOUCHER_STATE_UNKNOWN,
            overduedFilter:false,
            quotaFilter:false,
            rosturizmFilter:false,
        },
        orderFilters:{},
        taskFilters:{},
        userFilters:{
            activeFilter:true
        },
        paymentFilters:{},
        financeFilters:{},
        companyFilters:{
            typeFilter:CONSTANTS.COMPANY_TYPE_AGENCY
        },
        quotaFilters:{},
        pl: {
            teams:null,
            drivers:null,
            hotels:null,
            companies:null,
            companiesHotels:null,
            companiesAgencies:null,
            countries:null,
            booker_hotels:[],
            booker_rooms:[],
            booker_tarifs:[],
        },
        current_time: null,
        tablesFilter:{},
        tablesPagination:{},
        tablesSorting:{},
        bookingFilters:{
            booking_state_filter:null,
            booking_type_filter:null,
            hotel_filter:null,
            hotel_company_filter:null,
        },
    },
    mutations: {
        setNavMode(state, val) {
            this.state.navmode = val;
            switch (this.state.navmode) {
                case 'demo':
                    this.state.navmenu = navDemo;
                    break;
                case 'god':
                    this.state.navmenu = navGod;
                    break;
                case 'admin':
                    this.state.navmenu = navAdmin;
                    break;
                case 'agent':
                    this.state.navmenu = navAgent;
                    break;
                case 'agency':
                    this.state.navmenu = navAgency;
                    break;
                case 'manager':
                    this.state.navmenu = navManager;
                    break;
                case 'buh':
                    this.state.navmenu = navBuh;
                    break;
                case 'tech':
                    this.state.navmenu = navTech;
                    break;
                case 'jur':
                    this.state.navmenu = navJur;
                    break;
                case 'webm':
                    this.state.navmenu = navWebm;
                    break;
                default:
                    this.state.navmenu = navGuest;
                    break;
            }
        },
        setStatus(state, status) {
            this.state.status = status;
        },
        resetUser(state) {
            this.state.user = null;
            this.state.company = null;
            this.state.navmode = 'guest';
            this.state.navmenu = navGuest;
        },
        setAuthToken(state, authtoken) {
            this.state.authtoken = authtoken;
        },
        resetAuthToken(state) {
            this.state.authtoken = null;
        },
        setAuthUser(state, user) {
            this.state.user = user;
            this.state.company = this.state.user.company;

            //console.log("Роль: " + this.state.user.role_id);

            if (this.state.user.role_id & CONSTANTS.R_GOD) {
                //console.log("Интерфейс бога");
                this.state.navmode = 'god';
                this.state.navmenu = navGod;
            }
            else if (this.state.user.role_id & CONSTANTS.R_ADMIN) {
                //console.log("Интерфейс админа");
                this.state.navmode = 'admin';
                this.state.navmenu = navAdmin;
            }
            else if (this.state.user.role_id & CONSTANTS.R_BUH) {
                this.state.navmode = 'buh';
                this.state.navmenu = navBuh;
            }
            else if (this.state.user.role_id & CONSTANTS.R_MANAGER) {
                this.state.navmode = 'manager';
                this.state.navmenu = navManager;
            }
            else if (this.state.user.role_id & CONSTANTS.R_AGENCY) {
                this.state.navmode = 'agency';
                this.state.navmenu = navAgency;
            }
            else if (this.state.user.role_id & CONSTANTS.R_AGENT) {
                this.state.navmode = 'agent';
                this.state.navmenu = navAgent;
            }
            else if (this.state.user.role_id & CONSTANTS.R_TECH) {
                this.state.navmode = 'tech';
                this.state.navmenu = navTech;
            }
            else if (this.state.user.role_id & CONSTANTS.R_JUR) {
                this.state.navmode = 'jur';
                this.state.navmenu = navJur;
            }
            else if (this.state.user.role_id & CONSTANTS.R_WEBMASTER) {
                this.state.navmode = 'webm';
                this.state.navmenu = navWebm;
            }
        },
        setBaseUrl(state, data) {
            this.state.apibaseurl = data.apibaseurl;
            this.state.apiloginurl = data.apiloginurl;
        },
        saveVoucherFilters(state, filters) {
            this.state.voucherFilters.statusFilter = filters.statusFilter;
            this.state.voucherFilters.companyFilter = filters.companyFilter;
            this.state.voucherFilters.docCompanyFilter = filters.docCompanyFilter;
            this.state.voucherFilters.userFilter = filters.userFilter;
            this.state.voucherFilters.contactsFilter = filters.contactsFilter;
            this.state.voucherFilters.invoiceFilter = filters.invoiceFilter;
            this.state.voucherFilters.hotelFilter = filters.hotelFilter;
            this.state.voucherFilters.clientFilter = filters.clientFilter;
            this.state.voucherFilters.overduedFilter = filters.overduedFilter;
            this.state.voucherFilters.quotaFilter = filters.quotaFilter;
            this.state.voucherFilters.rosturizmFilter = filters.rosturizmFilter;
            this.state.voucherFilters.rangeCIFilter = Object.assign({}, filters.rangeCIFilter);
            this.state.voucherFilters.rangeCOFilter = Object.assign({}, filters.rangeCOFilter);
            this.state.voucherFilters.rangeCRFilter = Object.assign({}, filters.rangeCRFilter);
            this.state.voucherFilters.rangeSCFilter = Object.assign({}, filters.rangeSCFilter);
        },
        saveOrderFilters(state, filters) {
            this.state.orderFilters.statusFilter = filters.statusFilter;
            this.state.orderFilters.companyFilter = filters.companyFilter;
            this.state.orderFilters.userFilter = filters.userFilter;
            this.state.orderFilters.rangeFilter = Object.assign({}, filters.rangeFilter);
        },
        saveTaskFilters(state, filters) {
            this.state.taskFilters.filterFilter = filters.filterFilter;
            this.state.taskFilters.statusFilter = filters.statusFilter;
        },
        savePaymentFilters(state, filters) {
            this.state.paymentFilters.rangeFilter = Object.assign({}, filters.rangeFilter);
            this.state.paymentFilters.contractorFilter = filters.contractorFilter;
            this.state.paymentFilters.typeFilter = filters.typeFilter;
            this.state.paymentFilters.bindingFilter = filters.bindingFilter;
        },
        saveFinanceFilters(state, filters) {
            this.state.financeFilters.rangeFilter = Object.assign({}, filters.rangeFilter);
            this.state.financeFilters.contractorFilter = filters.contractorFilter;
            this.state.financeFilters.contractorTypeFilter = filters.contractorTypeFilter;
        },
        saveCompanyFilters(state, filters) {
            this.state.companyFilters.typeFilter = filters.typeFilter;
        },
        saveUserFilters(state, filters) {
            this.state.userFilters.companyFilter = filters.companyFilter;
            this.state.userFilters.activeFilter = filters.activeFilter;
        },

        savePreloadTeams(state, teams) {
            this.state.pl.teams = teams;
        },
        savePreloadDrivers(state, drivers) {
            this.state.pl.drivers = drivers;
        },
        savePreloadHotels(state, hotels) {
            this.state.pl.hotels = hotels;
        },
        savePreloadCompanies(state, companies) {
            this.state.pl.companies = companies;
        },
        savePreloadCountries(state, countries) {
            this.state.pl.countries = countries;
        },
        savePreloadCompaniesHotels(state, companies) {
            this.state.pl.companiesHotels = companies;
        },
        savePreloadCompaniesAgencies(state, companies) {
            this.state.pl.companiesAgencies = companies;
        },
        savePreloadBookerHotels(state, payload) {
            this.state.pl.booker_hotels[payload.booker_id] = payload.booker_hotels;
        },
        savePreloadBookerRooms(state, payload) {
            this.state.pl.booker_rooms[payload.booker_id+'--'+payload.hotel_id] = payload.booker_rooms;
        },
        savePreloadBookerPrograms(state, payload) {
            this.state.pl.booker_tarifs[payload.booker_id+'--'+payload.hotel_id] = payload.booker_tarifs;
        },
        setLatest(state, payload) {
            state.status.latest[payload.cls] = parseInt(payload.id);
        },
        setCurrentTime(state) {
            this.state.current_time = new Date();
        },
        saveTableState(state, payload) {
            console.log('saveTableState', payload)
            this.state.tablesFilter[payload.name] = Object.assign({}, payload.filter);
            this.state.tablesPagination[payload.name] = payload.pagination;
            this.state.tablesSorting[payload.name] = Object.assign({}, payload.sorting);
            console.log('payload.pagination', payload.pagination)
            console.log('this.state.tablesPagination[payload.name]', this.state.tablesPagination[payload.name])
            console.log('payload.sorting', payload.sorting)
            console.log('this.state.tablesSorting[payload.name]', this.state.tablesSorting[payload.name])
        },
        saveBookingFilters(state, filters) {
            console.log('saveBookingFilters')
            this.state.bookingFilters.hotel_filter = filters.hotel_filter;
            this.state.bookingFilters.hotel_filter = filters.hotel_filter;
            this.state.bookingFilters.booking_state_filter = filters.booking_state_filter;
            this.state.bookingFilters.booking_type_filter = filters.booking_type_filter;
            this.state.bookingFilters.no_sipplier_filter = filters.no_sipplier_filter;
        },
        saveQuotaFilters(state, filters) {
            console.log('saveQuotaFilters')
            this.state.quotaFilters.hotel_filter = filters.hotel_filter;
            this.state.quotaFilters.rangeFilter = Object.assign({}, filters.rangeFilter);
        },
    },

};

export {STORE}
